import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import notify from '../../shared/feedback/notifications';
import { impersonateCountry } from '../../actions/userActions';
import { Translate } from '../../shared/LanguageService';
import FormSelect from '../../components/common/FormSelect';

interface IImpersonateCountryFormProps {
    onUserCountryImpersonated(): void;
    onClose(): void;
    actions: {
        impersonateCountry(country: { id: number; name: string }): Promise<any>;
    };
    history: any;
    countries: { id: number; name: string }[];
    userDetails: { country: number };
}

class ImpersonateCountryForm extends React.Component<IImpersonateCountryFormProps, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { countryImpersonation: false, selectedSite: '' };
        this.impersonateCountry = this.impersonateCountry.bind(this);
        this.closeDropDown = this.closeDropDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    impersonateCountry(selectedItem: { id: number; name: string }) {
        if (selectedItem) {
            const { history } = this.props;
            this.props.actions.impersonateCountry(selectedItem);
            notify.success(Translate('impersonation/notification/now-impersonating-country'));
            this.props.onUserCountryImpersonated();
            history.push('/');
        }
    }

    handleChange(evt) {
        let country = this.props.countries.find((item) => evt.target.value === `${item.id}`);
        if (country) {
            this.impersonateCountry({
                id: country.id,
                name: Translate(country.name)
            });
        }
    }

    closeDropDown() {
        this.props.onClose();
    }

    getCountries() {
        return this.props.userDetails.country
            ? this.props.countries.filter((country) => {
                  return country.id !== this.props.userDetails.country;
              })
            : this.props.countries;
    }

    render() {
        return (
            <div className="customer-impersonation-form">
                <FormSelect
                    name="country"
                    onChange={this.handleChange}
                    value={this.state.selectedSite}
                    defaultTranslateKey="impersonation/form/select-label/select-country"
                >
                    {this.getCountries().map((e: any) => {
                        return (
                            <option key={e.id} value={e.id}>
                                {Translate(e.name)}
                            </option>
                        );
                    })}
                </FormSelect>
                <Button onClick={this.closeDropDown} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </Button>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        countries: state.systemInfo.countries,
        userDetails: state.user.details
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            impersonateCountry: (country: { id: number; name: string }) =>
                dispatch(impersonateCountry(country))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImpersonateCountryForm));
